import React from 'react';
import PropTypes from 'prop-types';

import styles from './Popup.css';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  textClass: PropTypes.string,
};

const defaultProps = {
  className: '',
  textClass: '',
};

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupEnabled: false,
    };
    this._enablePopup = this._enablePopup.bind(this);
    this._disablePopup = this._disablePopup.bind(this);
  }

  _enablePopup() {
    this.setState({
      popupEnabled: true,
    });
  }

  _disablePopup() {
    this.setState({
      popupEnabled: false,
    });
  }

  render() {
    return (
      <div
        className={styles.container}
        onMouseEnter={this._enablePopup}
        onMouseLeave={this._disablePopup}
      >
        {
          this.state.popupEnabled &&
          <div className={[this.props.className, styles.popup].join(' ')}>
            {this.props.children}
          </div>
        }
        <p className={[this.props.textClass, styles.text].join(' ')}>
          {this.props.text}
        </p>
      </div>
    );
  }
}

Popup.propTypes = IPropTypes;
Popup.defaultProps = defaultProps;

export { Popup };



// WEBPACK FOOTER //
// ./src/common/popup/Popup.jsx